import { LinkPreviewResponse } from '../models/LinkPreviewResponse';

export class WishListItem {
  id:string;
  user:string;
  title?:string;
  description?:string;
  image?:string;
  url?:string;
  created_date:Date
}



// WEBPACK FOOTER //
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/models/WishListItem.ts